import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'dino-cookie-consent';

const CookieConsentBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already consented.
    // localStorage is not available during server-side rendering, so we check for `window`.
    if (typeof window !== 'undefined') {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (consent !== 'true') {
        setIsVisible(true);
      }
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 flex flex-col sm:flex-row items-center justify-between z-50"
      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      <p className="text-sm mb-4 sm:mb-0 sm:mr-4">
        当サイトでは、ユーザー体験の向上とサイトの最適化のためにクッキーを使用しています。
        <Link to="/privacy" className="text-green-400 hover:text-green-300 underline ml-2">
          詳細はこちら
        </Link>
      </p>
      <button
        onClick={handleAccept}
        className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg transition-colors whitespace-nowrap"
      >
        同意して閉じる
      </button>
    </div>
  );
};

export default CookieConsentBanner;
